// ============================================
// CHÁMOMILE - Main App Component
// ============================================

import React from 'react';
import ChamomileApp from './ChamomileApp';

function App() {
  return <ChamomileApp />;
}

export default App;
